import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, BrowserXhr } from '@angular/http';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ComponentsModule } from './components/components.module';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { WebserviceService } from './services/webservice.service';
import { DatatransferService } from './services/datatransfer.service';
import { AuthGuard } from './services/canactivate.service';
import { SignupComponent } from './signup/signup.component';


import { ModalModule } from 'ngx-modialog';

import { HttpClientModule }    from '@angular/common/http';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { HighchartsChartModule } from 'highcharts-angular';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PagerService } from './services/pagerservice.service';


import {NgxPaginationModule} from 'ngx-pagination';
import {TabModule} from 'angular-tabs-component';
import {ChartModule,HIGHCHARTS_MODULES} from 'angular-highcharts';
import * as more from 'highcharts/highcharts-more.src';
import * as exporting from 'highcharts/modules/exporting.src';
import { NgxFileDropModule } from 'ngx-file-drop';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgxViewerModule } from 'ngx-viewer';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { Ng5SliderModule } from 'ng5-slider';
import { TooltipModule } from 'ngx-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';



import { VaveModule } from './vave/vave.module';
// import {AuthService} from './auth.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LoginComponent,
    SignupComponent
   
  ],
  imports: [
    NgMultiSelectDropDownModule,
    Ng5SliderModule,
    TooltipModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    RouterModule,
    AppRoutingModule,
    CommonModule,
    ComponentsModule,
    NgxPaginationModule,
    NgxFileDropModule,
    
    ModalModule.forRoot(),
    HttpClientModule,
    HighchartsChartModule,
    NgxSpinnerModule,
    TabModule,
    ChartModule,
    NgxDocViewerModule,
    NgxViewerModule,
    VaveModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA ],
  providers: [
    WebserviceService,
    AuthGuard,
    DatatransferService,
    PagerService,
    SidebarComponent,
    { provide: HIGHCHARTS_MODULES, useFactory: () => [ more, exporting ] },
    // AuthService
    
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
